// extracted by mini-css-extract-plugin
export default {"root":"Footer__root--31Ivx","button":"Footer__button--2iTiC","icon":"Footer__icon--3WoQ2"};